import { useTranslation } from "react-i18next";
import Icon from "../ui/Icons";
import { useSectionHref } from "../../seo/RouteContext";
import { NAP, telHref, whatsappHref } from "../../seo/site";
import "./QuickBar.css";

// Sticky bottom bar on phones: quote, click-to-call and WhatsApp.
export default function QuickBar() {
  const { t } = useTranslation();
  const sectionHref = useSectionHref();

  return (
    <div className="quickbar" role="region" aria-label={t("quickBar.quote")}>
      <a href={telHref} className="quickbar-btn" aria-label={t("quickBar.callAria", { phone: NAP.phoneDisplay })}>
        <Icon name="phone" size={20} />
        <span>{t("quickBar.call")}</span>
      </a>
      <a
        href={whatsappHref(t("quickBar.whatsappText"))}
        className="quickbar-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("quickBar.whatsappAria")}
      >
        <Icon name="whatsapp" size={20} />
        <span>{t("quickBar.whatsapp")}</span>
      </a>
      <a href={sectionHref("contacto")} className="quickbar-btn quickbar-quote">
        <span>{t("quickBar.quote")}</span>
        <Icon name="arrowRight" size={18} />
      </a>
    </div>
  );
}
